import React from 'react';

const TableCell = ({ children, className = '' }) => (
  <td className={`px-4 py-3 text-xs truncate min-w-[100px] max-w-[200px] ${className}`}>
    {children}
  </td>
);

export default TableCell;
